import { Card, CardBody } from '../ui/Card';
import { cn } from '../../utils/cn';
import type { ComplianceFrameworkSummary } from '../../types';

export function FrameworkSummaryCard({
  summary,
  active,
  onClick,
}: {
  summary: ComplianceFrameworkSummary;
  active: boolean;
  onClick: () => void;
}) {
  const tone = summary.readinessPercent >= 80 ? 'bg-pulse-500' : summary.readinessPercent >= 40 ? 'bg-amber-500' : 'bg-rose-500';

  return (
    <button onClick={onClick} className="text-left">
      <Card className={cn('transition-shadow', active && 'ring-2 ring-pulse-500')}>
        <CardBody>
          <div className="flex items-center justify-between">
            <p className="font-semibold text-slate-900 dark:text-white">{summary.label}</p>
            <p className="text-2xl font-bold tabular-nums text-slate-900 dark:text-white">{summary.readinessPercent}%</p>
          </div>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full transition-all', tone)} style={{ width: `${summary.readinessPercent}%` }} />
          </div>
          <div className="mt-3 flex flex-wrap gap-x-3 gap-y-1 text-xs text-slate-400">
            <span>{summary.evidencedCount} evidenced</span>
            <span>{summary.inProgressCount} in progress</span>
            <span>{summary.notStartedCount} not started</span>
            {summary.needsReviewCount > 0 && <span className="font-medium text-amber-600 dark:text-amber-400">{summary.needsReviewCount} need review</span>}
          </div>
        </CardBody>
      </Card>
    </button>
  );
}
